export function getCurrentStep(state) {
  return state.pairing.wizard.currentStep;
}
export function getInitialStep(state) {
  return state.pairing.wizard.initialStep;
}
